@if (scrolled) {
  <div class="btn-box-scroll-top">
    <button class="btn app-btn-primary scroll_top" (click)="scrollToTop()" tabindex="999" attr.aria-label="{{'Back to top' | translate}}">
      <i class="fa fa-angle-up" aria-hidden="true"></i>
      @if (shareDataService.isBpUp('md')) {
        <span class="pr-2" aria-hidden="true">{{'Back to top' | translate}}</span>
      }
    </button>
  </div>
}
